import { Check } from '@phosphor-icons/react';
import { SubScreen } from '../../components/layout/Screens';
import { SettingGroup, SettingRow } from '../../components/ui/Bits';
import { changerDeLangue, langue, LANGUES, t } from '../../i18n';

/**
 * Le choix de la langue, sur sa propre page.
 *
 * Tant que rien n'a ete choisi, Sirocco parle la langue du telephone, et
 * c'est elle qui est cochee : un iPhone en anglais voit « English »
 * coche des la premiere visite. La langue cochee vient en tete, les
 * autres suivent dans l'ordre alphabetique de leur nom. Choisir une autre langue l'impose a
 * Sirocco, et a lui seul. Chaque langue s'ecrit dans la sienne, pour
 * qu'on la reconnaisse sans lire les autres. Choisir recharge
 * l'application, qui revient sur cette page dans la nouvelle langue.
 */
const RANGEES = [
  ...LANGUES.filter((choix) => choix.code === langue),
  ...LANGUES.filter((choix) => choix.code !== langue).sort((a, b) => a.nom.localeCompare(b.nom)),
];

export function LangueScreen() {
  return (
    <SubScreen title={t.profil.reglages.langue}>
      <SettingGroup>
        {RANGEES.map(({ code, nom }) => (
          <SettingRow
            key={code}
            label={nom}
            trailing={
              code === langue ? (
                <Check size={20} weight="bold" className="setting-row__coche" />
              ) : (
                <span className="setting-row__coche setting-row__coche--vide" />
              )
            }
            onClick={() => {
              if (code !== langue) changerDeLangue(code);
            }}
          />
        ))}
      </SettingGroup>
    </SubScreen>
  );
}
